module.exports = __webpack_public_path__ + "img/alquiler de equipos viales 2.86dc04c2.png";